import { ampli } from '@/ampli';
import Link from 'next/link';

import { NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID } from '@/constants/addresses';

import { useTokenRoute } from '@/hooks/useTokenRoute';

import { buttons } from '@/styles/buttons';
import { fontStyles } from '@/styles/typography';

import { getChainIdNumberFromCaip2ChainId } from '@/utils/privy';

import { CHAIN_IDS, SUPPORTED_CHAIN_IDS_CROSS_CHAIN } from '../../../constants/chain';
import { useMatchaWallets } from '../../../hooks/useMatchaWallets';

export function CrossChainHero() {
  const { ethereumWallet } = useMatchaWallets();
  const tokenRoute = useTokenRoute();
  const connectedChainId = ethereumWallet
    ? getChainIdNumberFromCaip2ChainId(ethereumWallet.chainId)
    : undefined;

  // Cross-chain CTAs fall back to mainnet when the wallet chain has no cross-chain support.
  const chainId =
    connectedChainId !== undefined &&
    SUPPORTED_CHAIN_IDS_CROSS_CHAIN.indexOf(connectedChainId) !== -1
      ? connectedChainId
      : CHAIN_IDS.MAINNET;

  return (
    <>
      <header className="relative grid bg-[url('/images/crosschain/crosschain-lines.svg')] bg-cover bg-center bg-no-repeat pt-[152px] pb-24 after:absolute after:left-1/2 after:h-full after:w-full after:min-w-[3000px] after:-translate-x-1/2 after:bg-gradient-to-r after:from-white after:via-transparent after:to-white after:content-['']">
        <div className="tablet:px-[158px] z-[1] m-auto bg-[radial-gradient(50.13%_42.41%_at_50%_52.44%,#FFF_0%,#FFF_29.69%,rgba(255,255,255,0.64)_62.5%,rgba(255,255,255,0.00)_100%)] px-10 pt-24 pb-24">
          <h4
            className={`${fontStyles({ variant: 'H2', className: 'text-token-green-1000 text-center text-500 leading-14 font-bold' })} bg-[linear-gradient(rgba(2,168,99,1),rgba(2,168,99,0.49)),linear-gradient(rgba(118,182,36,1),rgba(36,182,77,0))] bg-clip-text [-webkit-text-fill-color:transparent]`}
          >
            Go where opportunity awaits
          </h4>
          <h1
            className={`${fontStyles({ variant: 'H1', className: 'tablet:text-[64px] tablet:leading-[78px] mb-6 grid text-center text-[46px] leading-[48px]' })}`}
          >
            Cross chain swaps
          </h1>
          <p
            className={`${fontStyles({ variant: 'BODY_LG', className: 'text-token-gray-800 mx-auto mb-12 grid max-w-[31rem] text-center' })}`}
          >
            Trade seamlessly across chains, with the aggregated liquidity you already know and love.
          </p>
          <div className="grid items-center justify-center">
            <Link
              onClick={() => ampli.tradingCtaClicked()}
              href={tokenRoute(
                { address: NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID[chainId], chainId },
                { mode: 'cross-chain' },
              )}
            >
              <div
                className={buttons({
                  className:
                    'px-4 shadow-[0px_-1px_1px_0px_rgba(0,0,0,0.04)_inset,0px_1px_3px_0px_rgba(0,0,0,0.20)]',
                  color: 'black',
                  shape: 'pill',
                  size: 'medium',
                })}
              >
                Start trading
              </div>
            </Link>
          </div>
        </div>
      </header>
    </>
  );
}
